import * as Sentry from '@sentry/react'

interface LogContext {
  [key: string]: unknown
}

export const logger = {
  debug: (message: string, context?: LogContext) => {
    if (import.meta.env.DEV) {
      console.debug(`[DEBUG] ${message}`, context)
    }
  },

  info: (message: string, context?: LogContext) => {
    if (import.meta.env.DEV) {
      console.info(`[INFO] ${message}`, context)
    }
  },

  warn: (message: string, context?: LogContext) => {
    console.warn(`[WARN] ${message}`, context)
    if (import.meta.env.PROD) {
      Sentry.captureMessage(message, { level: 'warning', extra: context })
    }
  },

  error: (message: string, error?: Error | unknown, context?: LogContext) => {
    console.error(`[ERROR] ${message}`, error, context)
    if (import.meta.env.PROD && error instanceof Error) {
      Sentry.captureException(error, { extra: context })
    }
  },
}
